import type { ListDealThreadsRequestContent, ListDealThreadsResponseContent } from '@equaliq/api-model';
import { createApiRequest } from '../common';

/**
 * List threads associated with a deal.
 * POST /deals/threads/list (flat route — dealId in body)
 */
export const listDealThreadsApi = async (
  dealId: string,
  request?: ListDealThreadsRequestContent
): Promise<ListDealThreadsResponseContent> => {
  const apiRequest = createApiRequest<ListDealThreadsResponseContent>(
    'post',
    '/deals/threads/list'
  );
  return apiRequest({ ...(request ?? {}), dealId });
};
